import { animate } from "//decked.com/cdn/shop/t/436/assets/static.vendor.min.js?v=161072099565793977701775152741";

var ProductOptions = class extends HTMLElement {

  constructor() {
    super();

    this.loading = false;
    this.initialized = false;
    this.selectedVariantID;
    this.moreInfoText = "i";
    this.reset(false);

    try{
      if(window.localStorage){
        this.presumedVehicle = JSON.parse(localStorage.getItem("selectedVehicle"));
      }
    }catch(e){
      console.error(e);
    }
    this.systemProductHandle = this.getAttribute("system-product-handle");
    this.systemProductTitle = this.getAttribute("system-product-title");
    this.resetUrl = this.getAttribute("reset-url");
    this.vehiclePicker = document.querySelector("vehicle-picker");

    window.addEventListener('vehicleSubmitted', (event) => {
      //console.log('Vehicle submitted');
      // TODO: why do we render this?
      this.renderSkeleton();
    });

    window.addEventListener("vehicleSelected", e => {
      //console.log('Vehicle selected');
      this.initByEvent("vehicleSelected");
    });

    window.addEventListener("vehicleJsonReady", e => {
      //console.log('json ready');
      this.initByEvent("vehicleJsonReady");
    });

    window.addEventListener("vehicleCleared", e => {
      //console.log('cleared');
      this.reset();
    });

    this.initByEvent("none")

  }

  reset(clearHtml = true) {
    // Variants filtered by Body Style & Bed Length, using Vehicle Object data
    
    this.initialized = false;

    this.filteredVariants = [];

    this.title = "";
    this.products = [];
    this.selections = new Map();
    this.unfilteredVariants = [];
    this.options = [];

    this.bodyStyleOptions = [];
    this.bedLengthOptions = [];

    this.option1 = "";
    this.option2 = "";
    this.option3 = "";

    this.bedLengthSelection = "";
    this.bodyStyleSelection = "";

    this.option1Selection = "";
    this.option2Selection = "";
    this.option3Selection = "";
    this.forceOptionsOpen = false;
    this.productSelected = false;

    if(clearHtml){
      requestAnimationFrame(() => {
        const height = this.height || this.clientHeight;
        this.height = 0;
        //this.innerHTML = "";
        animate(this, {
          height: [height + "px", 0 + "px"],
        }, 300)
      });
    }
    this.getVariantsWithCurrentSelections();
  }

  resetSelections() {
    this.bedLengthSelection = "";
    this.bodyStyleSelection = "";

    this.option1Selection = "";
    this.option2Selection = "";
    this.option3Selection = "";

    this.selections = new Map();
    this.forceOptionsOpen = false;
    this.productSelected = false;
    this.render();
  }


  initByEvent(ev){
    if(this.initialized) return;

    if (window.__VPV.vehicleSelected && window.__VPV.vehicleJsonReady && !this.initialized) {
      console.log(`init ------- `);
      this.init();
    }else if(window.__VPV.vehicleSelected === false && window.__VPV.vehicleJsonReady && !this.initialized){
      console.log(`reset ------- `);
      this.style.minHeight = '0';
      this.reset();
    }else{
      console.log(`else`);
      if( !this.loading && this.presumedVehicle && this.presumedVehicle.make && this.presumedVehicle.model && this.presumedVehicle.year ){ 
        console.log(`renderSkeleton ------- `);
        this.renderSkeleton();
      }
    }
  }

  init() {

    console.log("init");

    this.initialized = true;

    const selectedVehicle = VehicleData.getSelectedVehicle();
    let title, products;

    if (!selectedVehicle){
      console.log('No vehicle selected');
      this.sendInitEvent();
      return;
    }

    if (selectedVehicle && selectedVehicle.title) title = selectedVehicle.title;
    if (selectedVehicle && window.__VPV?.vehicleData?.byVehicle) products = window.__VPV.vehicleData.byVehicle;

    if (!products.length || window.__VPV.pdp.modelMismatch) {
      this.sendInitEvent();
      this.renderWarning(selectedVehicle);
      return;
    }

    this.selectedVehicle = selectedVehicle;
    this.title = title;
    this.style.display = "block";

    const uniqueVariantIds = [];

    this.bedLengthOptions = [];
    this.bodyStyleOptions = [];

    this.productJSONData = products;

    products.forEach(product => {
      const bedLength = product.bed_length ? product.bed_length.trim() : null;
      const bodyStyle = product.body_style ? product.body_style.trim() : null;

      if (!this.bedLengthOptions.includes(bedLength) && bedLength) this.bedLengthOptions.push(bedLength);
      if (!this.bodyStyleOptions.includes(bodyStyle) && bodyStyle) this.bodyStyleOptions.push(bodyStyle);

      product.products.forEach(variant => {
        if (!uniqueVariantIds.includes(variant.id)) uniqueVariantIds.push(variant.id);
      });
    });

    if (this.bodyStyleOptions.includes(selectedVehicle.body_style)) {
      this.bodyStyleSelection = selectedVehicle.body_style;
      this.selections.set("body_style", this.bodyStyleSelection);
    }
    if (this.bedLengthOptions.includes(selectedVehicle.bed_length)) {
      this.bedLengthSelection = selectedVehicle.bed_length;
      this.selections.set("bed_length", this.bedLengthSelection);
    }

    VehicleData.getProductDataByVariantIDs(uniqueVariantIds).then(vehicleData => {
      if (!vehicleData) return;
      this.unfilteredVariants = vehicleData.variants;
      this.filteredVariants = vehicleData.variants;
      this.filterVariants();

      vehicleData.variants.forEach(variant => {
        if (variant.id == VehicleData.selectedVariant){
          variant.selectedOptions.forEach((option, i) => {
            //this[`option${i + 1}Selection`] = option.value;
            this.selections.set(option.name, option.value);
          });
          this.selectedVariantID = variant.id;
        } 
        if (variant.selectedOptions[0]) this.option1 = variant.selectedOptions[0].name;
        if (variant.selectedOptions[1]) this.option2 = variant.selectedOptions[1].name;
        if (variant.selectedOptions[2]) this.option3 = variant.selectedOptions[2].name;
      });

      this.render();
      this.checkSelections();

      this.sendInitEvent();
    });
  }

  sendInitEvent() {
    window.dispatchEvent(
      new CustomEvent("optionsLoaded", {
        detail: {
          unfilteredVariants: this.unfilteredVariants,
          filteredVariants: this.filteredVariants,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  hide() {
    if(this.height === 0) return;
    const oldHeight = this.height || this.clientHeight;
    this.style.minHeight = '0';
    this.height = 0;
    animate(this, {
      height: [oldHeight + "px", 0 + "px"],
    }, 300)
    .finished
    .then(() => {
      this.style.display = "none";
    });
  }

  variantHasBodyStyle(variantID, bodyStyle) {
    let variantHasBodyStyle = false;

    this.productJSONData.forEach(product => {
      product.products.forEach(variant2 => {
        const variant2ID = this.extractVariantId(variant2.id);

        if (variant2ID == variantID && product.body_style == bodyStyle) {
          variantHasBodyStyle = true;
          return;
        }
      });
    });

    return variantHasBodyStyle;
  }

  variantHasBedLength(variantID, bedLength) {
    let variantHasBedLength = false;

    this.productJSONData.forEach(product => {
      product.products.forEach(variant2 => {
        const variant2ID = this.extractVariantId(variant2.id);

        if (variant2ID == variantID && product.bed_length == bedLength) {
          variantHasBedLength = true;
          return;
        }
      });
    });

    return variantHasBedLength;
  }

  getVariantBedLength(variantID) {
    let bed_length;
    const vehicleObjectsByVehicle = window.__VPV.vehicleData.byVehicle;

    vehicleObjectsByVehicle.forEach(product => {
      product.products.forEach(variant => {
        const variantID2 = this.extractVariantId(variant.id);
        if (variantID2 == variantID) bed_length = product.bed_length;
      });
    });

    if (bed_length) bed_length = bed_length.trim();

    return bed_length;
  }

  getVariantBodyStyle(variantID) {
    let body_style;
    const vehicleObjectsByVehicle = window.__VPV.vehicleData.byVehicle;

    vehicleObjectsByVehicle.forEach(product => {
      product.products.forEach(variant => {
        const variantID2 = this.extractVariantId(variant.id);
        if (variantID2 == variantID) body_style = product.body_style;
      });
    });

    if (body_style) body_style = body_style.trim();

    return body_style;
  }

  getBedLengthOptionsByBodyStyle(bodyStyle) {
    const vehicleObjectsByVehicle = window.__VPV.vehicleData.byVehicle;

    const bedLengthOptions = [];

    vehicleObjectsByVehicle.forEach(product => {
      if (!bodyStyle || (bodyStyle && product.body_style == bodyStyle)) {
        if (!bedLengthOptions.includes(product.bed_length)) bedLengthOptions.push(product.bed_length);
      }
    });

    bedLengthOptions.sort((a, b) => {
      const aLength = parseFloat(a.replace("'", ".").replace('"', "")); // converting 12'3'' to 12.3
      const bLength = parseFloat(b.replace("'", ".").replace('"', ""));
      return aLength - bLength;
    });

    return bedLengthOptions;
  }

  getVariantsWithCurrentSelections() {
    const variantsWithValues = [];

    this.filteredVariants.forEach(variant => {
      const variantHasBedLength = this.variantHasBedLength(variant.id, this.bedLengthSelection);
      const variantHasBodyStyle = this.variantHasBodyStyle(variant.id, this.bodyStyleSelection);

      if (this.bodyStyleSelection && !variantHasBodyStyle) return;
      if (this.bedLengthSelection && !variantHasBedLength) return;

      const variantselectedOption1 = variant.selectedOptions[0];
      const variantselectedOption2 = variant.selectedOptions[1];
      const variantselectedOption3 = variant.selectedOptions[2];

      if (this.option1Selection && this.option1Selection != variantselectedOption1.value) return;
      if (this.option2Selection && this.option2Selection != variantselectedOption2.value) return;
      if (this.option3Selection && this.option3Selection != variantselectedOption3.value) return;

      variantsWithValues.push(variant);

    });

    window.__VPV.pdp.remainingVariants = variantsWithValues;

    window.dispatchEvent(
      new CustomEvent("remainingVariants:change", {
        detail: {
          remainingVariants: variantsWithValues,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );


    return variantsWithValues;
  }

  getAvailableOptionValues(optionNumber, optionName) {
    const optionValues = [];
    const optionIndex = optionNumber - 1;

    //go through variants and collect remaining vehicles
    const remainingVehicles = {};
    const { bodyStyleSelection, bedLengthSelection } = this;
    this.filteredVariants.forEach(variant => {

      //find vehicle that has this variant
      const vehicle = window.__VPV.vehicleData.byVehicle.find(vehicle => {
        if((bedLengthSelection && vehicle.bed_length != bedLengthSelection) ||
            (bodyStyleSelection && vehicle.body_style != bodyStyleSelection)){
          //vehicle doesn't match selected bed length or body style
          return false;
        }
        const hasVariant = vehicle.products.find(product => {
          return product.id === variant.gid;
        });
        return hasVariant;
      });

      if(vehicle){
        //build unique key for vehicle
        const vehicleKey = `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.body_style} ${vehicle.bed_length}`;
        remainingVehicles[vehicleKey] = remainingVehicles[vehicleKey] || [];
        remainingVehicles[vehicleKey].push(variant);
      }

    });

    //collect options from the first vehicle
    const firstVehicleVariants = Object.values(remainingVehicles)[0] || [];
    const self = this;
    firstVehicleVariants.forEach(variant => {
      let variantMatches = true;
      for(let i = 0; i < optionIndex; i++){
        if(self[`option${i+1}Selection`] && self[`option${i+1}Selection`] != variant.selectedOptions[i].value){
          //variant doesn't match selected option
          variantMatches = false;
          continue;
        }
      }
      if(variantMatches){
        //add value to options
        const value = variant.selectedOptions[optionIndex]?.value;
        optionValues.indexOf(value) === -1 && optionValues.push(value);
      }
    });

    let sortedOptionValues;

    if (optionName == 'CargoGlide Extension'){

      sortedOptionValues = optionValues.sort((a, b) => {
        return parseInt(a) - parseInt(b);
      });

    } else {
      sortedOptionValues = optionValues;
    }

    return sortedOptionValues;
  }

  getInputTypeByParams({ name, systemProductHandle, values = [] }) {

    // Hide Length if every value is a Bed Length value (meaning it's a redundant option)
    if (name === "Length") {
      const parsedBedLengths = [...this.bedLengthOptions].map(bedLength => bedLength.replace(/\s/g, ""));
      const arraysEqual = [...values].every((bedLength, i) => {
        return parsedBedLengths.includes(bedLength.replace(/\s/g, ""));
      });
      if (arraysEqual) return "hidden";
    }

    if (systemProductHandle === "decked-tool-box" && (name === "bed_length" || name === "body_style")) {
      return "hidden";
    } else if (systemProductHandle === "decked-tool-box" && (name === "Truck" || name === "Edition") && values.length === 1) {
      return "hidden";
    } else if (name === "Truck" && (this.bedLengthOptions.length > 1 || this.bodyStyleOptions.length > 1)) {
      return "hidden";
    } else if (name === "Year") {
      return "hidden";
    } else if (values.length === 1) {
      return "hidden";
    } else {
      return "radio";
    }
  }

  getProductMetafield(metafield) {
    if (this.filteredVariants.length && this.filteredVariants[0] && this.filteredVariants[0].productMetafields) return this.filteredVariants[0].productMetafields[metafield];
  }

  renderOption(option, values) {
    if(!option || !values.length) return null;
    
    const $options = document.createElement("div");

    let optionName;
    let alwaysShowOption = false;

    $options.setAttribute("data-option", `${option}`);
    $options.classList.add("option");

    const $optionName = document.createElement("div");
    const $optionValues = document.createElement("div");
    const $optionInner = document.createElement("div");
    const $optionNameLegend = document.createElement("legend");

    let inputType = this.getInputTypeByParams({
      name: option,
      systemProductHandle: window.__VPV?.pdp?.productHandle,
      values: values,
    });

    if (option == "bed_length" && this.getProductMetafield("always_show_bed_length")) alwaysShowOption = true;
    if (option == this.option2 && this.getProductMetafield("always_show_option2")) alwaysShowOption = true;
    if (option == this.option3 && this.getProductMetafield("always_show_option3")) alwaysShowOption = true;

    if (option == "bed_length" && this.getProductMetafield("length_label")) {
      optionName = this.getProductMetafield("length_label");
    } else {
      optionName = option.replace("_", " ");
    }

    if (alwaysShowOption) {
      inputType = "radio";
    } else if (inputType == "hidden") {
      return null;
    }

    if (inputType != "hidden") {
      $optionName.classList.add("variant-picker__option-info");
      $optionInner.classList.add("h-stack", "gap-2", "items-baseline");
      $optionValues.classList.add("variant-picker__option-values", "wrap", "gap-2");
      
      $optionNameLegend.innerText = optionName;
      $optionInner.appendChild($optionNameLegend);
      $optionName.appendChild($optionInner);

      $options.appendChild($optionName);
    }

    for (const i in values) {
      const value = values[i];

      const $label = document.createElement("label");
      const $labelSpan = document.createElement("span");
      const $div = document.createElement("div");
      const $input = document.createElement("input");
      let selected = false;

      $input.classList.add("sr-only");

      $label.setAttribute("for", `${option}__${i}`);
      if (inputType != "hidden") {
        $labelSpan.innerText = value;
        $label.appendChild($labelSpan);
      }

      $input.setAttribute("id", `${option}__${i}`);
      $input.setAttribute("type", "radio");
      $input.setAttribute("name", option);
      $input.setAttribute("value", value);
      $input.addEventListener("change", ev => {
        window.setTimeout(() => {
          this.optionChange(ev.target);
        }, 0);
      });
      
      if (this.selections.get(option) == value || values.length == 1){ 
        $input.setAttribute("checked", "checked");
        $options.classList.add("option--selected");
        selected = true;
      }

      if( optionName.toLowerCase().indexOf("color") > -1 ){
        let jsonString = document.getElementById("ColorSwatchSettings")?.innerHTML;
        let swatchConfig;
        try{
          swatchConfig = JSON.parse(jsonString)
        }catch(e){
          console.error(e);
          swatchConfig = {};
        }
        // color swatch
        $label.classList.add("color-swatch", "rounded-full");
        $labelSpan.classList.add("sr-only");
        const valueDowncase = value.toLowerCase();
        if(swatchConfig[valueDowncase]){
          if(swatchConfig[valueDowncase].indexOf("#") > -1){
            const luminance = getLuminance(swatchConfig[valueDowncase]);
            if(luminance > .9){
              $label.classList.add("border");    
            }
          }
          $label.style.setProperty("--swatch-background", swatchConfig[valueDowncase]);
        }else{
          $label.style.setProperty("--swatch-background", valueDowncase);
        }

        if(selected){
          const $optionValue = document.createElement("div");
          $optionValue.innerText = value;
          $optionInner.appendChild($optionValue);
        }

      }else{
        $label.classList.add("block-swatch");
      }

      $div.classList.add("optionValue");
      $div.appendChild($input);
      $div.appendChild($label);

      $optionValues.appendChild($div);
    }

    $options.appendChild($optionValues);

    return $options;

    // return values.map(value => `<span><input name='${option}' type='radio'>${value}</span>`);
  }

  getOptionNumberByName(optionName) {
    let optionNumber;

    if (this.option1 == optionName) {
      optionNumber = 1;
    } else if (this.option2 == optionName) {
      optionNumber = 2;
    } else if (this.option3 == optionName) {
      optionNumber = 3;
    }

    return optionNumber;
  }

  optionChange($option) {

    // clear variant from url
    const url = new URL(window.location);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);

    this.forceOptionsOpen = false;
    const selectedVehicle = VehicleData.getSelectedVehicle();

    if ($option.name == "bed_length") {
      this.bedLengthSelection = $option.value;
      // save bed length selection to vehicle data
      VehicleData.selectVehicle({
        ...selectedVehicle,
        bed_length: $option.value,
      });
    } else if ($option.name == "body_style") {
      this.resetSelections();
      this.bodyStyleSelection = $option.value;
      // save body style selection to vehicle data
      VehicleData.selectVehicle({
        ...selectedVehicle,
        body_style: $option.value,
        bed_length: null,
      });
    } else if (this.option1 == $option.name) {
      this.option1Selection = $option.value;
      
      console.log("select options!");
      const option2values = this.getAvailableOptionValues(2, this.option2);
      if (option2values.length == 1) {
        this.option2Selection = option2values[0];
      }else if( !option2values.includes(this.option2Selection) ) {
        this.option2Selection = "";
      }

      const option3values = this.getAvailableOptionValues(3, this.option3);
      if (option3values.length == 1) {
        this.option3Selection = option3values[0];
      }else if( !option3values.includes(this.option3Selection) ) {
        this.option3Selection = "";
      }
    } else if (this.option2 == $option.name) {
      this.option2Selection = $option.value;
      
      const option3values = this.getAvailableOptionValues(3, this.option3);
      if (option3values.length == 1) {
        this.option3Selection = option3values[0];
      }else if( !option3values.includes(this.option3Selection) ) {
        this.option3Selection = "";
      }
    } else if (this.option3 == $option.name) {
      this.option3Selection = $option.value;
    }

    this.selections.set($option.name, $option.value);
    //this.checkSelections();
    this.filterVariants();

    const variantsWithValues = this.getVariantsWithCurrentSelections();

    this.render();

    // Defer analytics and events to avoid blocking INP
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("optionSelected", {
          detail: {
            option: $option.name,
            value: $option.value,
            filteredVariants: variantsWithValues,
          },
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );

      dataLayer.push({
        event: "product_option_selected",
        option_name: $option.name,
        option_value: $option.value
      });
    }, 0);
  }

  filterVariants() {
    // Filter Vehicle Objects by Body Style and Bed Length
    const vehicleObjects = window.__VPV.vehicleData.byVehicle;
    let filteredVehicleObjects;
    if (this.bodyStyleSelection || this.bedLengthSelection) {
      filteredVehicleObjects = vehicleObjects.filter(obj => {
        const satisfiesBodyStyle = this.bodyStyleSelection ? this.bodyStyleSelection === obj.body_style : true;
        const satisfiesBedLength = this.bedLengthSelection ? this.bedLengthSelection === obj.bed_length : true;
        return satisfiesBodyStyle && satisfiesBedLength;
      });
    } else {
      filteredVehicleObjects = vehicleObjects;
    }

    // Filter variants based on filteredVehicleObjects
    this.filteredVariants = this.unfilteredVariants.filter(variantData => {
      return filteredVehicleObjects.some(vehicleObj => {
        return vehicleObj.products.some(variant => {
          return variantData.gid === variant.id;
        });
      });
    });
  }

  extractVariantId(url) {
    const regex = /ProductVariant\/(\d+)/;
    const match = url.match(regex);
    if (match) {
      return match[1];
    } else {
      throw new Error("Invalid URL");
    }
  }

  changeVehicle() {
    VehicleData.reset();
    this.hide();
    document.querySelector("vehicle-picker").open();
  }

  getSelectedVariantsMinPrice() {
    const variantsWithValues = this.getVariantsWithCurrentSelections();

    let price, currencyCode;

    variantsWithValues.forEach(variant => {
      if (variant.price.amount < price || !price) {
        price = variant.price.amount;
        currencyCode = variant.price.currencyCode;
      }
    });

    return `${price} ${currencyCode}`;
  }

  getInputValueByName(inputName) {
    const $input = this.querySelector(`[name='${inputName}']`);
    if (!$input) return;

    if ($input.getAttribute("type") == "radio") {
      return this.querySelector(`[name='${inputName}']:checked`) && this.querySelector(`[name='${inputName}']:checked`).value;
    } else {
      return $input.value;
    }
  }

  checkSelections() {
    // Check/set initial non-Shopify option selections
    this.bodyStyleSelection = this.getInputValueByName("body_style");
    this.bedLengthSelection = this.getInputValueByName("bed_length");

    // Sync selections map
    this.selections.set("body_style", this.bodyStyleSelection);
    this.selections.set("bed_length", this.bedLengthSelection);
    this.selections.set(this.option1, this.option1Selection);
    this.selections.set(this.option2, this.option2Selection);
    this.selections.set(this.option3, this.option3Selection);
  }

  getProductOptionsTitle() {
    var attributes = [];

    if (this.bodyStyleOptions.length > 1) {
      attributes.push(this.bodyStyleSelection || this.bodyStyleOptions[0]);
    }

    const bedLengthOptionsByBodyStyle = this.getBedLengthOptionsByBodyStyle(this.bodyStyleSelection)
    if (bedLengthOptionsByBodyStyle.length > 1 || this.getProductMetafield("always_show_bed_length")) {
      attributes.push(this.bedLengthSelection || bedLengthOptionsByBodyStyle[0]);
    }

    if (typeof this.option1 !== "undefined" 
        && this.option1 != "" 
        && this.getAvailableOptionValues(1, this.option1).length > 1) {
      attributes.push(this.option1Selection || this.getAvailableOptionValues(1, this.option1)[0]);
    }
    if (typeof this.option2 !== "undefined" 
        && this.option2 != "" 
        && (this.getAvailableOptionValues(2, this.option2).length > 1 || this.getProductMetafield("always_show_option2"))) {
      attributes.push(this.option2Selection || this.getAvailableOptionValues(2, this.option2)[0]);
    }
    if (typeof this.option3 !== "undefined" 
        && this.option3 != "" 
        && (this.getAvailableOptionValues(3, this.option3).length > 1 || this.getProductMetafield("always_show_option3"))) {
      attributes.push(this.option3Selection || this.getAvailableOptionValues(3, this.option3)[0]);
    }

    return attributes.join(" / ");
  }

  renderProductInfo() {
    const $container = document.createElement("div");
    $container.classList.add("product-info__product-container");

    const $title = document.createElement("div");
    $title.classList.add("product-info__title", "text-lg");
    $title.innerText = "Product Selection";
    $container.appendChild($title);

    const $vehicle = document.createElement("div");
    $vehicle.classList.add("product-info__product");
    $container.appendChild($vehicle);

    const $text = document.createElement("span");
    $text.classList.add("product-info__product-title");
    $text.innerText = this.getProductOptionsTitle();
    $vehicle.appendChild($text);

    const $changeProduct = document.createElement("a");
    $changeProduct.classList.add("change-product", "link");
    $changeProduct.innerText = window.themeVariables?.strings?.vehicle_picker?.change || "Change";
    $changeProduct.addEventListener("click", () => {
      this.forceOptionsOpen = true;
      this.render();
    });
    $vehicle.appendChild($changeProduct);

    return $container;
  }

  renderVehicleInfo() {
    const $container = document.createElement("div");
    $container.classList.add("product-info__vehicle-container");

    const $title = document.createElement("div");
    $title.classList.add("product-info__title", "text-lg");
    $title.innerText = "Your Vehicle";
    $container.appendChild($title);

    const $vehicle = document.createElement("div");
    $vehicle.classList.add("product-info__vehicle");
    $container.appendChild($vehicle);

    if(window.__VPV?.urlSetVehicleData){
      const $vehicleURLWarning = document.createElement("p");
      $vehicleURLWarning.classList.add("mt-2", "text-warning");
      $vehicleURLWarning.innerHTML = "This vehicle was automatically selected from your search. Make sure it's correct.";
      
      $vehicleURLWarning.addEventListener("click", () => {
        this.changeVehicle();
      });

      $container.appendChild($vehicleURLWarning);
    }

    const params = new URLSearchParams(window.location.search);
    if(this.selectedVehicle){
      params.set("make", this.selectedVehicle.make);
      params.set("model", this.selectedVehicle.model);
      params.set("year", this.selectedVehicle.year);
    }

    const $text = document.createElement("a");
    $text.classList.add("product-info__vehicle-title");
    $text.innerText = this.title;
    $text.href = `${location.pathname}?${params.toString()}`;
    $vehicle.appendChild($text);

    const $changeVehicle = document.createElement("a");
    $changeVehicle.classList.add("change-vehicle", "link");
    if(this.resetUrl){
      $changeVehicle.href = this.resetUrl;
    }
    $changeVehicle.innerText = window.themeVariables?.strings?.vehicle_picker?.change || "Change";
    $changeVehicle.addEventListener("click", () => {
      this.changeVehicle();
    });
    $vehicle.appendChild($changeVehicle);

    return $container;
  }

  renderSkeleton() {

    const $vehicle = this.renderVehicleInfo();
    this.appendChild($vehicle);

    //set height temporarily to prevent layout shift
    console.log('render skeleton', this.height);
    const oldHeight = this.height || this.clientHeight;
    this.style.height = oldHeight + "px";

    for (let i = 0; i < 2; i++) {
      const option = document.createElement("div");
      option.classList.add("option");

      const optionName = document.createElement("div");
      optionName.classList.add("optionName");
      option.appendChild(optionName);

      const optionTitle = document.createElement("span");
      optionTitle.classList.add("skeleton", "skeleton--text", "skeleton--text-lg");
      optionTitle.style.width = "30%";
      optionName.appendChild(optionTitle);

      const optionValues = document.createElement("div");
      optionValues.classList.add("flex", "mt-2","gap-2");
      option.appendChild(optionValues);

      for (let j = 0; j < 3 - i; j++) {
        const optionButton = document.createElement("div");
        optionButton.classList.add("skeleton", "skeleton--button-md");
        optionButton.style.width = j + i == 1 ? "60px" : "80px";
        optionValues.appendChild(optionButton);
      }

      this.appendChild(option);
    }

    this.style.minHeight = '0';
    this.style.height = 'auto';
    const newHeight = this.clientHeight;
    this.height = newHeight;

    animate(this, {
      height: [oldHeight + "px", newHeight + "px"],
    }, 300)
    .finished
    .then(() => {
      this.style.height = 'auto';
    });

    this.loading = true;

  }

  render() {

    this.loading = false;

    try{
      this.vehiclePicker.hideSelects();
    }catch(e){
      console.error(e);
    }

    //set height temporarily to prevent layout shift
    const oldHeight = this.height || this.clientHeight;
    this.style.height = oldHeight + "px";

    this.innerHTML = '';

    const $vehicle = this.renderVehicleInfo();
    this.appendChild($vehicle);

    const variantsWithValues = this.getVariantsWithCurrentSelections();
    window.__VPV.pdp.selectedOptions = this.selections;

    const $options = document.createElement("div");
    
    if (this.bodyStyleOptions.length > 0) {
      const $bodyStyleOption = this.renderOption("body_style", this.bodyStyleOptions);
      $bodyStyleOption && $options.appendChild($bodyStyleOption);
    }

    if (this.bodyStyleOptions.length == 1) {
      this.selections.set("body_style", (this.bodyStyleSelection = this.bodyStyleOptions[0]));
    }

    const bedLengthOptionsByBodyStyle = this.getBedLengthOptionsByBodyStyle(this.bodyStyleSelection)
    if (bedLengthOptionsByBodyStyle.length > 0) {
      const $bedLengthOption = this.renderOption("bed_length", bedLengthOptionsByBodyStyle);
      $bedLengthOption && $options.appendChild($bedLengthOption);
    }

    const option1El = this.renderOption(this.option1, this.getAvailableOptionValues(1, this.option1));
    option1El && $options.appendChild(option1El);

    if (typeof this.option2 !== "undefined" && this.option2 != "" && this.getAvailableOptionValues(2, this.option2).length){
      const option2El = this.renderOption(this.option2, this.getAvailableOptionValues(2, this.option2));
      option2El && $options.appendChild(option2El);
    } 
    if (typeof this.option3 !== "undefined" && this.option3 != "" && this.getAvailableOptionValues(3, this.option3).length){
      const option3El = this.renderOption(this.option3, this.getAvailableOptionValues(3, this.option3));
      option3El && $options.appendChild(option3El);
    }

    this.appendChild($options);

    const notesVariant = this.unfilteredVariants.find(variant => window.__VPV.vehicleData.byVehicle[0].products[0].id.indexOf(variant.id) > -1);
    if (notesVariant) this.renderToolTips(notesVariant);

    if(variantsWithValues.length == 1) {
      const selectedVariant = variantsWithValues[0];
      this.selectVariant(selectedVariant);
    }

    window.setTimeout(() => {
      this.style.minHeight = '0';
      this.style.height = 'auto';
      const newHeight = this.clientHeight;
      this.height = newHeight;

      animate(this, {
        height: [oldHeight + "px", newHeight + "px"],
      }, 300)
      .finished
      .then(() => {
        if(newHeight == 0){
          this.style.display = "none";
        }
        this.style.height = 'auto';
      });
    }, 100);

  }

  renderWarning(selectedVehicle) {
    const { modelMismatch } = window.__VPV.pdp;
    const existingWarning = this.querySelector(".options-vehicle-warning");
    if (existingWarning) {
      existingWarning.remove();
    }
    const warning = document.createElement("div");
    warning.classList.add("options-vehicle-warning", "banner", "banner--error", "banner--with-button", "mb-3");

    const htmlModelMismatch = `
      <p><span class="options-vehicle-warning__lead">Click to verify your vehicle fitment.</span></p>
      <span class="options-vehicle-warning__change button button--sm">Verify fitment</span>
    `
    const htmlNoProduct = `
      <p><span class="options-vehicle-warning__lead">This product does not fit your selection of</span>
      <span class="options-vehicle-warning__vehicle">${selectedVehicle.title}</span></p>
      <span class="options-vehicle-warning__change button button--sm">Change</span>
    `
    warning.innerHTML = modelMismatch ? htmlModelMismatch : htmlNoProduct;
    warning.addEventListener("click", e => {
      this.changeVehicle();
    });
    
    this.prepend(warning);
    
    const currentHeight = this.clientHeight;
    this.style.height = "auto";
    this.style.minHeight = '0';
    this.height = this.clientHeight;

    if(currentHeight === this.height) return;

    this.style.height = currentHeight + "px";

    animate(this, {
      height: [currentHeight + "px", this.height + "px"],
    }, 300)
    
  }

  selectVariant(variant) {
    const variantId = variant.id;

    this.selectedVariantID = variantId;
    this.renderToolTips(variant);

    window.setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("variantSelected", {
          detail: variant,
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: {
            variant: variant
          }
        })
      );
    },0);
  }

  createTooltip(id, href, text) {
    const $container = document.createElement("span");
    $container.classList.add("inline", "tooltip-container");

    const $helptext = document.createElement("a");
    $helptext.classList.add("link", "helptext");
    $helptext.setAttribute("href", href);
    $helptext.setAttribute("target", "_blank");
    $helptext.setAttribute("rel", "noopener noreferrer");
    $helptext.setAttribute("aria-controls", id);
    $helptext.innerText = text || "What's this?";

    const drawerHTML = "<ajax-drawer id='" + id + "' href='" + href + "' class='drawer drawer--center drawer--sm' template='drawer-no-header-template' open-from='bottom' role='dialog' aria-modal='true'></ajax-drawer>";

    $container.appendChild($helptext);
    $container.insertAdjacentHTML('beforeend', drawerHTML);

    return [$container];
  }

  renderToolTips(variant) {
    if (variant.variantBodyNote) {
      const $tooltip = this.createTooltip('variant_body_note', `/pages/${variant.variantBodyNote.value}`, variant.productMetafields.body_style_helptext);
      const $option = this.querySelector(`[data-option=body_style]`);
      if($option){ 
        const $optionName = $option?.querySelector(".variant-picker__option-info .h-stack");
        const $oldTooltip = $option?.querySelector(".tooltip-container")
        $oldTooltip && $oldTooltip.remove();
        const $oldHelptext = $option?.querySelector(".helptext")
        $oldHelptext && $oldHelptext.remove();

        $optionName.appendChild($tooltip[0]);
      }
    }

    if (variant.productMetafields.bed_note) {
      const $tooltip = this.createTooltip('variant_bed_note', `/pages/${variant.productMetafields.bed_note}`, variant.productMetafields.length_helptext);
      const $option = this.querySelector(`[data-option=bed_length]`);
      if($option){ 
        const $optionName = $option.querySelector(".variant-picker__option-info .h-stack");
        const $oldTooltip = $option.querySelector(".tooltip-container")
        $oldTooltip && $oldTooltip.remove();
        const $oldHelptext = $option.querySelector(".helptext")
        $oldHelptext && $oldHelptext.remove();

        $optionName.appendChild($tooltip[0]);
      }
    }

    if (variant.productMetafields.option2_note) {
      const $tooltip = this.createTooltip('variant_option2_note', `/pages/${variant.productMetafields.option2_note}`, variant.productMetafields.option2_helptext);
      const $option = this.querySelector(`[data-option="${this.option2}"]`);
      if($option){ 
        const $optionName = $option.querySelector(".variant-picker__option-info .h-stack");
        const $oldTooltip = $option.querySelector(".tooltip-container")
        $oldTooltip && $oldTooltip.remove();
        const $oldHelptext = $option.querySelector(".helptext")
        $oldHelptext && $oldHelptext.remove();

        $optionName.appendChild($tooltip[0]);
      }
    }

    if (variant.productMetafields.option3_note) {
      const $tooltip = this.createTooltip('variant_option3_note', `/pages/${variant.productMetafields.option3_note}`, variant.productMetafields.option3_helptext);
      const $option = this.querySelector(`[data-option="${this.option3}"]`);
      if($option){ 
        const $optionName = $option.querySelector(".variant-picker__option-info .h-stack");
        const $oldTooltip = $option.querySelector(".tooltip-container")
        $oldTooltip && $oldTooltip.remove();
        const $oldHelptext = $option.querySelector(".helptext")
        $oldHelptext && $oldHelptext.remove();

        $optionName.appendChild($tooltip[0]);
      }
    }
  }

};

if (!window.customElements.get("product-options")) {
  window.customElements.define("product-options", ProductOptions);
}


function getLuminance(hexColor) {
  // Remove the hash if present
  const hex = hexColor.replace('#', '');
  
  // Parse r, g, b values
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  
  // Apply gamma correction
  const rLinear = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  const gLinear = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  const bLinear = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
  
  // Calculate relative luminance (WCAG formula)
  return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
}